import { ValidatedTextInputField } from 'common';
import React from 'react';
import { UserFormInput, UserFormInputCommonProps } from '../types';
import { userInputValidationRules } from '../../../domain/validationRules';

export const FirstNameInput = (passthroughsProps: UserFormInputCommonProps) => {
    return (
        <ValidatedTextInputField<UserFormInput>
            {...passthroughsProps}
            name='firstName'
            label={<span className='text-base font-normal'>First Name</span>}
            placeholder='John'
            maxLength={userInputValidationRules.maxLength.value}
            onBlur={e => e.target.value = e.target.value.trim()}
            validationRules={userInputValidationRules}
        />
    );
}
